export default __webpack_public_path__ + "static/media/Arimo-Bold.7b7636b2.ttf";